@if (isActive) {
  <div>
    <p>{{'LINK.ACTIVE' | translate}}</p>
  </div>
}
